import { useLocation } from 'react-router-dom';

const useIsImport = () => {
  const { pathname } = useLocation();

  return /\/import/i.test(pathname);
};

export default useIsImport;
